import { render, staticRenderFns } from "./queues-table.vue?vue&type=template&id=f70eec66&"
import script from "./queues-table.vue?vue&type=script&lang=js&"
export * from "./queues-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports